import { BASE_URL } from "./constant";

const API_BASE = (process.env.REACT_APP_API_BASE || BASE_URL || "").replace(/\/+$/, "");

function buildUrl(path, params = {}) {
  const url = new URL(`${API_BASE}${path}`);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

async function request(path, options = {}) {
  const response = await fetch(buildUrl(path, options.params), {
    method: options.method || "GET",
    headers: options.body ? { "Content-Type": "application/json" } : undefined,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.error || "Erreur notifications");
  }

  return payload;
}

export function fetchNotifications(params = {}) {
  return request("/api/notifications", { params });
}

export function markNotificationRead(id, payload = {}) {
  return request(`/api/notifications/${id}/read`, {
    method: "POST",
    body: payload,
  });
}

export function markAllNotificationsRead(payload = {}) {
  return request("/api/notifications/read-all", {
    method: "POST",
    body: payload,
  });
}
